import { createContext, useContext } from "react";

import type { User } from "./types";

export interface AuthContext {
  user: User | null;
  signIn: () => void;
  signOut: () => void;
}

export const AuthCtx = createContext<AuthContext>({
  user: null,
  signIn: () => {},
  signOut: () => {},
});

export const useAuth = () => useContext(AuthCtx);
